import React, {Component}               from 'react';
import PropTypes                        from 'prop-types';
import { browserHistory }               from 'react-router';
import FullPageSpinner                  from '../../Fragments/FullPageSpinner';
import ResidentialReferenceRequest      from './Residential';
import EmployerReferenceRequest         from './Employer';
import SelfEmployedReferenceRequest     from './SelfEmployed';
import PensionProviderReferenceRequest  from './PensionProvider';
import SubmitInput                      from '../../Fields/SubmitInput';

let HttpService = require('../../Managers/HttpService');
let Quote = require('../../Managers/Quote');
let form = '';

class ReferenceRequest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFullPageSpinnerActive: true,
            applicantDetails: null,
            refereeName: null,
            formLoaded: false,
            isDataLoaded: false,
        };
        this.inputComponents = [];
        this.childComponents = [];
    }

    componentWillMount() {
        // Clear values to prevent anomalies in state
        window.localStorage.clear();

        // Get the user IP
        HttpService.getIp('Referee.refereeIpAddress');

        let uuidFormat = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        if ( ! this.props.params.linkref || ! uuidFormat.test(this.props.params.linkref)) {
            // No linkref = error page
            browserHistory.push('/error/no-auth');
            return false;
        } else if ( ! this.props.params.type) {
            // No referee type = error page
            browserHistory.push('/error/no-referee-type');
        } else {
            HttpService.setLinkRef(this.props.params.linkref);

            // Run promise chain to get the relevant applicant details -> set
            // the legal footer -> load in the sub-form -> set letting agent
            // details
            HttpService.getRetrieveApplication(HttpService.getLinkRef())
            .then((data) => {
                this.setState({
                    applicantDetails: {
                        "title": data.title,
                        "firstName": data.firstName,
                        "lastName": data.lastName,
                        "referenceNumber": data.referenceNumber,
                        "referenceType": data.referenceType,
                        "nationalInsuranceNumber": data.financialReferees[0] ? data.financialReferees[0].nationalInsuranceNumber : "Not provided",
                        "payrollNumber": data.financialReferees[0] ? data.financialReferees[0].payrollNumber : "Not provided"
                    }
                });

                // Set the referee 'name' based on the type. We have no way to
                // get a specific financial referee name, so in this instance,
                // we only set the name if there's on;y one financial referee in
                // the array, thanks to how the API is built.
                switch(this.props.params.type) {
                    case 'letting':
                        this.setState({ refereeName: data.lettingReferee.name });
                        break;
                    case 'employer':
                    case 'self-employed':
                    case 'retired':
                        if (data.financialReferees.length === 1) {
                            this.setState({ refereeName: data.financialReferees[0].companyName });
                        }
                        break;
                    default:
                        browserHistory.push('/error/invalid-referee-type');
                        break;
                }
            })
            .then(() => {
                this.getLegalData();
            })
            .then(() => {
                this.getSubForm();
            });
        }
    }

    componentWillUpdate() {
        this.inputComponents = [];
    }

    componentWillUnmount() {
        this.inputComponents = [];
    }

    /**
     * Retrieve the legal texts for this domain, inject into the footer
     */
    getLegalData() {
        HttpService.getPrivateLegalTexts(HttpService.getLinkRef())
        .then(() => {
            document.getElementById('copyright-notice').innerHTML = Quote.getByPath('domainInfo.copyrightNotice');
            document.getElementById('mainPhone').innerHTML = Quote.getByPath('domainInfo.generalTelephone');
        });
    }

    /**
     * Set the sub-form to render based on URL parameters
     */
    getSubForm() {
        switch(this.props.params.type) {
            case 'letting':
                form = <ResidentialReferenceRequest source={'Referee'} ref={(instance) => {this.childComponents.push(instance);}} />;
                this.setState({ formLoaded: true });
                break;
            case 'employer':
                form = <EmployerReferenceRequest source={'Referee'} ref={(instance) => {this.childComponents.push(instance);}} />;
                this.setState({ formLoaded: true });
                break;
            case 'self-employed':
                form = <SelfEmployedReferenceRequest source={'Referee'} ref={(instance) => {this.childComponents.push(instance);}} />;
                this.setState({ formLoaded: true });
                break;
            case 'retired':
                form = <PensionProviderReferenceRequest source={'Referee'} ref={(instance) => {this.childComponents.push(instance);}} />;
                this.setState({ formLoaded: true });
                break;
            default:
                browserHistory.push('/error/invalid-referee-type');
                break;
        }

        this.setState({
            isDataLoaded: true,
            isFullPageSpinnerActive: false
        });
    }

    submitReferee() {
        this.setState({ isFullPageSpinnerActive: true });

        let inputComponents = [];

        this.childComponents.filter(c => {
            return (c !== undefined) && (c !== null);
        }).map(c => {
            inputComponents = inputComponents.concat(c.getChildInputComponents());
        });

        inputComponents = inputComponents.concat(this.inputComponents).filter(c => {
            return (c !== undefined) && (c !== null);
        });

        inputComponents.map(v => {
            v.getChildInstance().handleValidation(v.getChildInstance().getCurrentValue());
        });

        // Round down any contract duration on the off chance that the user has
        // added it with a decimal.
        if (!window.uornorb(Quote.getByPath('Referee.contractDuration'))) {
            let duration = Math.floor(Number(Quote.getByPath('Referee.contractDuration')));
            Quote.setByPath('Referee.contractDuration', duration);
        }

        setTimeout(() => {
            this.setState({ isFullPageSpinnerActive: false });
            if (document.querySelectorAll('.has-error').length > 0) {
                $('html, body').animate({
                    scrollTop: $(".has-error").first().offset().top - $('header.site-header').height()
                }, 500);
            } else {
                // Because 'invalid date' as a string is an invalid date - I
                // know, shocking - we wipe it here so the object can be parsed
                // by the API validation.
                if (String(Quote.getByPath('Referee.employmentEndDate')) === 'Invalid date') {
                    Quote.deleteByPath('Referee.employmentEndDate');
                }

                HttpService.postReferee(HttpService.getLinkRef(), this.props.params.type);
            }
        }, 1000);
    }

    /**
     * Get a formatted title for the referee type
     *
     * @param type
     * @returns {*}
     */
    getTypeTitle(type) {
        switch(type) {
            case 'self-employed':
                return 'Accountant';
            case 'retired':
                return 'Pension provider';
            default:
                type = type[0].toUpperCase() + type.substring(1);
                return type;
        }
    }

    render() {
        return (
            <div>
                <FullPageSpinner
                    isActive={this.state.isFullPageSpinnerActive}
                />

                {/* Once the data is loaded in, we can show the application/referee data */}
                {this.state.isDataLoaded === true ?
                    <question-row class="header-row">
                        {this.props.params.type === 'employer' ?
                            <div className={'summary-widget pull-right'}>
                                 <section className={'pod'}>
                                     <header className={'header'}>
                                        <h3>{this.state.applicantDetails.title} {this.state.applicantDetails.firstName} {this.state.applicantDetails.lastName}</h3>
                                     </header>
                                     <div className={'content'}>
                                         <div>
                                             <div className={'row-value'}>
                                                 <div className={'column row-label'}>NI number</div>
                                                 <div className={'column'}>
                                                     {this.state.applicantDetails.nationalInsuranceNumber ? this.state.applicantDetails.nationalInsuranceNumber : "Not provided"}
                                                 </div>
                                             </div>
                                             <div className={'row-value'}>
                                                 <div className={'column row-label'}>Payroll number</div>
                                                 <div className={'column'}>
                                                     {this.state.applicantDetails.payrollNumber ? this.state.applicantDetails.payrollNumber : "Not provided"}
                                                 </div>
                                             </div>
                                         </div>
                                     </div>
                                 </section>
                            </div>
                        : null}
                        <h1>{this.getTypeTitle(this.props.params.type)} referee request {this.state.refereeName ? <span>- {this.state.refereeName}</span> : null}</h1>
                        {this.state.applicantDetails.referenceType === 2 ?
                            <p style={{lineHeight: 1.4}}>
                                <b>{this.state.applicantDetails.title} {this.state.applicantDetails.firstName} {this.state.applicantDetails.lastName}</b> has
                                applied to act as a guarantor for a tenancy application under the application
                                reference <b>{this.state.applicantDetails.referenceNumber}</b>. Please fill out the
                                requested details below so we can continue our referencing process.</p>
                            :
                            <p style={{lineHeight: 1.4}}>
                                <b>{this.state.applicantDetails.title} {this.state.applicantDetails.firstName} {this.state.applicantDetails.lastName}</b> has
                                applied to move into a new rented property under the application
                                reference <b>{this.state.applicantDetails.referenceNumber}</b>. Please fill out the
                                requested details below so we can continue our referencing process.</p>
                        }
                    </question-row>
                : null}

                {/* Once we have validated the referee type and linkRef, show the sub-form */}
                {this.state.formLoaded === true ?
                    <div>
                        {form}

                        <SubmitInput
                            label="Submit"
                            callbackFunction={this.submitReferee.bind(this)}
                            backLink={false}
                        />
                    </div>
                : null}
            </div>
        );
    }
}

ReferenceRequest.propTypes = {
    params: PropTypes.object,
};

export default ReferenceRequest;



// WEBPACK FOOTER //
// ./src/components/Screens/ReferenceRequest/Index.js